import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ButtonComponent,
  HeadlineComponent,
} from '@zeiss/beyond-online-angular';
import { ConsentState } from '../../services/consent-state';

@Component({
  selector: 'app-consent-dialog-content',
  templateUrl: './consent-dialog-content.html',
  styleUrl: './consent-dialog-content.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslocoDirective, ButtonComponent, HeadlineComponent],
  host: {
    class: 'consent-dialog-content',
  },
})
export class ConsentDialogContent {
  private consentState = inject(ConsentState);

  public isLoading = this.consentState.isLoading;

  public agreed = output<void>();
  public cancelled = output<void>();

  public onAgree() {
    this.agreed.emit();
  }

  public onCancel() {
    this.cancelled.emit();
  }
}
